<template>
    <button
        v-routing-animation="{speedModifier: 50, index: 2}"
        class="Button"
        :class="{
            'Button--primary': primary,
            'Button--secondary': secondary,
            'Button--tertiaryWhite': tertiaryWhite,
            'Button--tertiaryBlue': tertiaryBlue,
            'Button--large': large,
            'Button--small': small
        }"
        :disabled="disabled"
        @click="onClick"
    >
        {{ label }}
    </button>
</template>
<script>
export default {
    name: 'HempelButton',
    props: {
        label: {
            type: String,
            required: true
        },
        primary: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        secondary: {
            type: Boolean,
            default: false
        },
        tertiaryWhite: {
            type: Boolean,
            default: false
        },
        tertiaryBlue: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick(e) {
            if (this.url.length > 0) {
                window.open(this.url, '_blank')
            } else this.$emit('click', e)
        }
    }
}
</script>
